// extracted by mini-css-extract-plugin
export default {"customHeader":"Header_customHeader__MPePO","navigation":"Header_navigation__lSgkJ","previousMonth":"Header_previousMonth__yOfeD","nextMonth":"Header_nextMonth__-fdLR"};